import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { apiClient } from './client';

/** The agency's text opt-out list (JT1-1857). Admins only. */
export interface SmsOptOut {
  id: string;
  phone: string;
  /** How it happened, ready to show: "Replied STOP", "Added by hand", ... */
  how: string;
  reason: 'STOP' | 'PROVIDER_OPT_OUT' | 'MANUAL' | 'BOUNCE' | 'COMPLAINT';
  source: string | null;
  opted_out_at: string;
  added_by: string | null;
  note: string | null;
}

const KEY = ['sms-suppressions'];

export function useSmsOptOuts() {
  return useQuery<SmsOptOut[]>({
    queryKey: KEY,
    queryFn: async () => (await apiClient.get<{ data: SmsOptOut[] }>('/sms-suppressions')).data.data,
  });
}

export function useAddSmsOptOut() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (input: { phone: string; note?: string }) =>
      (await apiClient.post('/sms-suppressions', input)).data,
    onSuccess: () => qc.invalidateQueries({ queryKey: KEY }),
  });
}

export function useRemoveSmsOptOut() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async ({ id, reason }: { id: string; reason: string }) =>
      (await apiClient.delete<{ data: { removed: boolean; needs_start_reply: boolean } }>(`/sms-suppressions/${id}`, { data: { reason } }))
        .data.data,
    onSuccess: () => qc.invalidateQueries({ queryKey: KEY }),
  });
}
